import { LocationContext } from "context/ViewContext/LocationContext";
import { useProviderInitializedContext } from "./useProviderInitializedContext";

export const useLocation = () => {
  return useProviderInitializedContext(LocationContext);
};
